export default "__VITE_ASSET__1acb36e2__"